import { version } from '../../package.json';
import { Router } from 'express';
import User from '../models/user'
import facets from './facets';

export default ({ config, db }) => {
	let api = Router();

	// mount the facets resource
	api.use('/facets', facets({ config, db }));

	// perhaps expose some API metadata at the root
	api.get('/', (req, res) => {
		res.json({ version });
	});
    api.post('/register', (req,res,next) =>{
        User.register(req.body,function (err,user) {
            if(err)throw err ;
            res.json(user);
        })})


	return api;
}
